import { useFirestoreQueryData } from "@react-query-firebase/firestore";
import { collection, limit, orderBy, query, where } from "firebase/firestore";
import { firestore } from "../firebase";

const useGetFeaturedPhotos = (board) => {

    const postsCollection = collection(firestore, "photos");

    let postsQuery = query(postsCollection, limit(10), where("board", "==", board), where("featured","==", true), orderBy("name", "asc"));
   
    const posts = useFirestoreQueryData(["pictures", board, false], postsQuery);

    return {...posts, data: posts?.data?.length || 0}
}

export default useGetFeaturedPhotos